import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import ContactImg from '../../assets/img/AboutUs/contactus.jpg';
import { ContactForm } from '../../components/ContactForm';
import contactInfo from '../../constants/contactInfo.json';

const Contact: React.FC = () => {
  return (
    <div className="contact-page">
      <div className="breadcrumbs">
        <div className="shell breadcrumbs-inner">
          <h1>Contact Us</h1>
          <ul className="breadcrumb-list">
            <li><Link to="/">Home</Link></li>
            <li className="active">Contact Us</li>
          </ul>
        </div>
      </div>

      <div className="shell">
        <div className="hero-grid" style={{ padding: '40px 0' }}>
          <div className="hero-copy">
            <h2 className="section-title">Get in <span className="text-gradient">Touch</span></h2>
            <p className="lead" style={{ marginBottom: '30px' }}>
              We're here to help you with any questions or information you may need. 
              Reach out to us through any of the following methods.
            </p>

            <div className="glass-card" style={{ padding: '30px', marginBottom: '30px' }}>
              <h3 style={{ color: 'var(--accent)', marginBottom: '20px' }}>Our Office</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', color: 'var(--text-main)', fontSize: '15px' }}>
                {contactInfo.addresses.map((address) => (
                  <div key={address} style={{ display: 'flex', gap: '12px' }}>
                    <MapPin size={20} className="text-gradient" />
                    <span>{address}</span>
                  </div>
                ))}
                {contactInfo.phones.map((phone) => (
                  <div key={phone} style={{ display: 'flex', gap: '12px' }}>
                    <Phone size={20} className="text-gradient" />
                    <a href={`tel:${phone}`} style={{ color: 'var(--text-main)' }}>{phone}</a>
                  </div>
                ))}
                <div style={{ display: 'flex', gap: '12px' }}>
                  <Mail size={20} className="text-gradient" />
                  <a href={`mailto:${contactInfo.email}`} style={{ color: 'var(--accent)', fontWeight: 'bold' }}>{contactInfo.email}</a>
                </div>
              </div>
            </div>

            <ContactForm />
          </div>

          <div className="hero-visual">
            <div className="glass-card" style={{ padding: '0' }}>
               <img src={ContactImg} alt="Contact Us" style={{ width: '100%', borderRadius: '20px' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
